// extracted by mini-css-extract-plugin
export const ldsRing = "loading-module--lds-ring--11CAm";